module.exports = __webpack_public_path__ + "static/media/align-right.fb1e76cf.svg";